import {SubVerifierDetails} from '@toruslabs/customauth';

export const AUTH0_DOMAIN = 'https://gvmo.us.auth0.com';

export const GOOGLE_VERIFIER_DETAILS: SubVerifierDetails = {
  typeOfLogin: 'google',
  verifier: 'epoch-google',
  clientId: '962313737544-ikp2bgoshin44l24ep3k9fitmv2nv4i5.apps.googleusercontent.com',
};

export const LINKEDIN_VERIFIER_DETAILS: SubVerifierDetails = {
  typeOfLogin: 'linkedin',
  verifier: 'epoch-clan-auth0-linkedin',
  clientId: 'pfkos5eETfdlymW5O9qdwc3y2JmbKEW7',
  jwtParams: {
    domain: AUTH0_DOMAIN,
  },
};

export const PASSWORDLESS_VERIFIER_DETAILS: SubVerifierDetails = {
  typeOfLogin: 'email_password',
  verifier: 'epoch-clan-auth0-email-password',
  clientId: 'pfkos5eETfdlymW5O9qdwc3y2JmbKEW7',
  jwtParams: {domain: AUTH0_DOMAIN},
};
